/**
 * KeyCode contains namings for JS Keyboard event keyCode values
 */
export var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["Backspace"] = 8] = "Backspace";
    KeyCode[KeyCode["Tab"] = 9] = "Tab";
    KeyCode[KeyCode["Enter"] = 13] = "Enter";
    KeyCode[KeyCode["Shift"] = 16] = "Shift";
    KeyCode[KeyCode["Control"] = 17] = "Control";
    KeyCode[KeyCode["Alt"] = 18] = "Alt";
    KeyCode[KeyCode["Escape"] = 27] = "Escape";
    KeyCode[KeyCode["Space"] = 32] = "Space";
    KeyCode[KeyCode["LeftArrow"] = 37] = "LeftArrow";
    KeyCode[KeyCode["UpArrow"] = 38] = "UpArrow";
    KeyCode[KeyCode["RightArrow"] = 39] = "RightArrow";
    KeyCode[KeyCode["DownArrow"] = 40] = "DownArrow";
    KeyCode[KeyCode["Delete"] = 46] = "Delete";
    KeyCode[KeyCode["Comma"] = 188] = "Comma";
    KeyCode[KeyCode["Period"] = 190] = "Period";
    KeyCode[KeyCode["Meta"] = 224] = "Meta";
})(KeyCode || (KeyCode = {}));
export var controlKeyDict = {
    Backspace: true,
    Tab: true,
    Enter: true,
    Shift: true,
    Control: true,
    Alt: true,
    Escape: true,
    ' ': true,
    ArrowLeft: true,
    ArrowUp: true,
    ArrowRight: true,
    ArrowDown: true,
    Delete: true,
    Meta: true
};
//# sourceMappingURL=keycodes.js.map